export default __webpack_public_path__ + "static/media/pekalongan.12c7bb17.jpg";